<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              {{ $t('gr301.title') }}
            </div>
          </section>
          <section class="section02">
            <div class="object01"></div>
            <div class="object02">
              <div class="object0201">
                <div class="item01">
                  {{ $t('gr301.lastUpdated') }}
                </div>
                <div class="item02">
                  {{formatKstToLocal(pinRealTimeData.updateAt)}}
                </div>
                <div class="item03" @click="setData">
                  {{ $t('gr301.refresh') }}
                </div>
              </div>
            </div>
            <div class="object03" v-show="userInfo.userRole !== 'ClubManager'" v-if="false">
              <div class="form">
                <div class="formSelect" ref="select01">
                  <!--<div class="formSelectList" @click="openSelect01">-->
                  <div class="formSelectList">
                    <input type="text" v-model="currentClubInfo.club_name" :placeholder="$t('gr301.selectGolfClubPlaceholder')" readonly />
                  </div>
                  <div class="formSelectPopup typeSearch select01">
                    <div class="formSelectPopup-container">
                      <div class="outer">
                        <div class="inner">
                          <div class="formSelectPopup-box">
                            <div class="formSelectPopup-zone">
                              <div class="formSelectPopup-header">
                                <input type="text" :placeholder="$t('gr301.selectGolfClubPlaceholder')" v-model="searchValue" v-on:keyup="changeSearchValue" />
                              </div>
                              <ul class="formSelectPopup-body">
                                <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                                  <label>
                                    <input type="radio" v-model="selectCcode" :value="clubInfo.ccode" v-on:change="confirmSelect01()"/>
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                                  </label>
                                </li>
                              </ul>
                              <div class="formSelectPopup-footer">
                                <button class="formSelectPopup-cancel" @click="closeSelectAll()">
                                  {{ $t('common.cancel') }}
                                </button>
                                <!-- 비활성(Attribute) : disabled -->
                                <button class="formSelectPopup-confirm" @click="confirmSelect01()">
                                  {{ $t('common.confirm') }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section03">
            <!-- 기간별 그린 온도 활성(Class) : term -->
            <div class="object01">
              <div class="title">
                <ul class="list">
                  <li class="time">
                    {{ $t('gr301.realTimePinPosition') }}
                  </li>
                  <li class="term" @click="moveMenu(`/GR302` + getCurrentCcodeParam())">
                    {{ $t('gr301.periodPinPosition') }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="object02">
              <div class="formSelect" ref="select02">
                <div class="formSelectList" @click="openSelect02">
                  <input type="text" :value="$t('gr301.realTimePinPosition')" readonly />
                </div>
                <div class="formSelectPopup select02">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" :placeholder="$t('gr301.selectTypePlaceholder')" />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li @click="closeSelectAll">
                                <label>
                                  <input type="radio" checked/>
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{ $t('gr301.realTimePinPosition') }}</span>
                                </label>
                              </li>
                              <li @click="moveMenu('/GR302')">
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{ $t('gr301.periodPinPosition') }}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                {{ $t('common.cancel') }}
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                {{ $t('common.confirm') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="section04">
            <div class="object01">
              <div class="object0101">
                <div class="course">
                  <div class="title">
                    {{ $t('common.course') }}
                  </div>
                  <div class="formSelect" ref="select03">
                    <div class="formSelectList" @click="openSelect03">
                      <input type="text" v-model="currentCourseInfo.name" :placeholder="$t('common.course')" readonly />
                    </div>
                    <div class="formSelectPopup select03">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input type="text" :placeholder="$t('gr301.selectTypePlaceholder')" />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li v-for="courseInfo in courseList" :key="courseInfo.courseId">
                                    <label>
                                      <input type="radio" v-model="selectCourseId" :value="courseInfo.courseId" v-on:change="confirmSelect03()"/>
                                      <input type="checkbox" />
                                      <i></i>
                                      <span>{{courseInfo.name}}</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    {{ $t('common.cancel') }}
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    {{ $t('common.confirm') }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="hole">
                  <div class="title">
                    {{ $t('common.hole') }}
                  </div>
                  <div class="formSelect" ref="select04">
                    <div class="formSelectList" @click="openSelect04">
                      <input type="text" v-model="currentHoleNo" :placeholder="$t('common.hole')" readonly />
                    </div>
                    <div class="formSelectPopup select04">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input type="text" :placeholder="$t('common.hole')" />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li v-for="i in (currentCourseInfo.endIdx - currentCourseInfo.startIdx)" :key="i">
                                    <label>
                                      <input type="radio" v-model="selectHlidx" :value="((i-1) + currentCourseInfo.startIdx)" v-on:change="confirmSelect04()"/>
                                      <input type="checkbox"  />
                                      <i></i>
                                      <span>Hole {{viewHoleNo(i + currentCourseInfo.startIdx - 1)}}</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    {{ $t('common.cancel') }}
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    {{ $t('common.confirm') }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="object0102">
                <div class="item">
                  <div class="item01">
                    <div class="item0101">
                      {{ $t('gr301.startTime') }}
                    </div>
                    <div class="item0102">
                      {{viewStartTime}} ~
                    </div>
                  </div>
                  <div class="item02">
                    <div class="item0201">
                      {{ $t('gr301.duration') }}
                    </div>
                    <div class="item0202" v-html="viewDurationTime">
                    </div>
                  </div>
                </div>
              </div>
              <div class="object0103" @click="confirmSendAlarm">
                {{ $t('gr301.sendPinErrorAlert') }}
              </div>
              <!-- 툴팁 활성(Class) : tooltipActive -->
              <div class="object0104" :class="tooltipActive ? 'tooltipActive' : ''"  @click="openTooltip" ref="tooltip">
                <div class="tooltip">
                  {{ $t('gr301.tooltip') }}
                </div>
              </div>
              <div class="object0105">
                <div class="content">
                  <div class="pin" style="line-height: 0; text-align: center;">
                    <div class="object"></div>
                    <div class="flagZone">
                      <!-- 위치값(Style) : x, y 좌표 -->
                      <div class="flagObject" v-if="pinPostion.x !== 0 && pinPostion.y !== 0" :style="{'top': pinPostion.y+'px', 'left': pinPostion.x+'px'}">
                        {{ $t('gr301.flag') }}
                      </div>
                      <div
                        v-if="pinRealTimeData.pinInfo.grsel"
                        style="position: absolute; top:70px; right: 70px; width: 20px; height: 20px; line-height: 20px; font-size: 20px;">
                        {{pinRealTimeData.pinInfo.grsel}}
                      </div>
                    </div>
                    <div style="display: inline-block; position: relative; width:100%; height:100%; line-height: 1.5;" :style="{'background-image': 'url(' + pinRealTimeData.imageInfo.imageUrl + ')', 'background-repeat': 'no-repeat', 'background-size': 'contain', 'background-position': 'center center'}"></div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div :class="beforeConfirm ? 'alert' : 'alert typeConfirm'">
        <div class="container">
          <div class="outer">
            <div class="inner">
              <div class="box">
                <div class="zone">
                  <div class="body" v-html="alertBodyHTML">
                  </div>
                  <div class="footer">
                    <button class="cancel" @click="closeAndCancelAlert">
                      {{ $t('common.cancel') }}
                    </button>
                    <button class="confirm" @click="closeAlert">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup typeSearch select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr301.selectGolfClubPlaceholder')" v-model="searchValue" v-on:keyup="changeSearchValue" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="clubInfo in selectClubInfoList" :key="clubInfo.ccode">
                      <label>
                        <input type="radio" v-model="selectCcode" :value="clubInfo.ccode" v-on:change="confirmSelect01()"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{clubInfo.club_name === undefined ? '' : clubInfo.club_name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel" @click="closeSelectAll()">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm" @click="confirmSelect01()">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr301.selectTypePlaceholder')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li @click="closeSelectAll">
                      <label>
                        <input type="radio" checked/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ $t('gr301.realTimePinPosition') }}</span>
                      </label>
                    </li>
                    <li @click="moveMenu(`/GR302` + getCurrentCcodeParam())">
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ $t('gr301.periodPinPosition') }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select03">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select03">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('gr301.selectTypePlaceholder')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="courseInfo in courseList" :key="courseInfo.courseId">
                      <label>
                        <input type="radio" v-model="selectCourseId" :value="courseInfo.courseId" v-on:change="confirmSelect03()"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{courseInfo.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select04">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select04">
                  <div class="formSelectPopup-header">
                    <input type="text" :placeholder="$t('common.hole')" />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="i in (currentCourseInfo.endIdx - currentCourseInfo.startIdx)" :key="i">
                      <label>
                        <input type="radio" v-model="selectHlidx" :value="((i-1) + currentCourseInfo.startIdx)" v-on:change="confirmSelect04()"/>
                        <input type="checkbox"  />
                        <i></i>
                        <span>Hole {{viewHoleNo(i + currentCourseInfo.startIdx - 1)}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      {{ $t('common.cancel') }}
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      {{ $t('common.confirm') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import {clubInfoService, commonService, gcsService, settingService, userService} from '../../router'

import moment from 'moment'
import { formatKstToLocal } from '../../util/timezone'

export default {
  name: 'GR301',
  data () {
    return {
      beforeConfirm: true,
      alertBodyHTML: '',
      callback: null,
      pinRealTimeData: {
        updateAt: '',
        imageInfo: {},
        pinInfo: {
          duration: 0
        }
      },
      currentHoleInfo: {
        aplId: '',
        battery: '',
        grsel: 'L',
        hlidx: '',
        isActive: true,
        lat: '',
        lon: '',
        lowBattery: false,
        nhole: '',
        temp: null,
        updateAt: ''
      },
      viewDurationTime: '',
      viewStartTime: '',
      mapAreaSize: 0,
      selectCourseId: '',
      selectHlidx: 0,
      currentHlidx: 0,
      pinGps: {
        lat: null,
        lon: null
      },
      pinPostion: {
        x: 0,
        y: 0
      }
    }
  },
  created: function () {
    userService.getAll().then(response => {
      this.userInfo = response.data
      clubInfoService.getClubInfoList('active').then(response => {
        this.clubInfoList = response.data.clubInfoList
        this.selectClubInfoList = response.data.clubInfoList
        if (this.userInfo.userRole === 'ClubManager') {
          this.currentClubCode = this.userInfo.ccode
        } else {
          if (this.$route.query.ccode === undefined) {
            this.currentClubCode = this.clubInfoList[0].ccode
          } else {
            this.currentClubCode = this.$route.query.ccode
          }
          this.setClubInfo()
        }
        this.selectCcode = this.currentClubCode
        commonService.getCourseListByCcode(this.currentClubCode).then(response => {
          this.courseList = response.data.courseList.sort((a, b) => a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0)
          for (let i in this.courseList) {
            let holeCnt = this.courseList[i].endIdx - this.courseList[i].startIdx
            if (this.maxHoleCnt < holeCnt) this.maxHoleCnt = holeCnt
          }
          if (this.courseList[0] !== undefined) {
            this.currentCourseInfo = this.courseList[0]
            this.selectCourseId = this.currentCourseInfo.courseId
          }
          this.setData()
        }).catch(error => {
          console.log('getCourseListByCcode.err.===>', error)
        })
      }).catch(error => {
        console.log('getClubInfoListByStatusActive.err.===>', error)
      })
    })
  },
  mounted: function () {
    if (document.querySelector('.object0105 .content') === null) return false
    this.mapAreaSize = document.querySelector('.object0105 .content').clientHeight
    window.addEventListener('resize', this.resizeEvt)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.resizeEvt)
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
      gcsService.getPinRealTime(this.currentClubCode, this.currentHlidx).then(response => {
        this.pinRealTimeData = response.data.pinRealTimeData
        this.setStartTime(this.pinRealTimeData.pinInfo.duration)
        this.setDurationTime(this.pinRealTimeData.pinInfo.duration)
        this.setPinGps(this.pinRealTimeData.pinInfo)
      }).catch(error => {
        console.log('getPinRealTime.err.===>', error)
      })
    },
    getCurrentCcodeParam: function () {
      let currentCcode = localStorage.getItem('currentCcode')
      if (currentCcode) {
        return `?ccode=${currentCcode}`
      } else {
        return ''
      }
    },
    formatKstToLocal: formatKstToLocal,
    getCourseData: function (hlidx) {
      return this.courseList.find(it => ((it.startIdx <= hlidx) && (it.endIdx > hlidx)))
    },
    viewHoleNo: function (hlidx) {
      let startIdx = this.getCourseData(hlidx) === undefined ? 0 : this.getCourseData(hlidx).startIdx
      return (hlidx - startIdx) + 1
    },
    confirmSelect01: function () {
      this.currentClubCode = this.selectCcode
      this.setClubInfo()
      this.selectHlidx = 0
      this.currentHlidx = this.selectHlidx
      commonService.getCourseListByCcode(this.currentClubCode).then(response => {
        this.courseList = response.data.courseList.sort((a, b) => a.startIdx < b.startIdx ? -1 : a.startIdx > b.startIdx ? 1 : 0)
        this.currentCourseInfo = this.courseList[0]
        this.selectCourseId = this.currentCourseInfo.courseId
        this.setData()
      }).catch(error => {
        console.log('getCourseListByCcode.err.===>', error)
      })
      this.closeSelectAll()
    },
    confirmSelect03: function () {
      this.currentCourseInfo = this.courseList.find(it => it.courseId === this.selectCourseId)
      this.selectHlidx = this.currentCourseInfo.startIdx
      this.confirmSelect04()
      this.closeSelectAll()
    },
    confirmSelect04: function () {
      this.currentHlidx = this.selectHlidx
      this.setData()
      this.closeSelectAll()
    },
    setDurationTime: function (duration) {
      let m = Math.floor((duration) % 60)
      let h = Math.floor((duration - m) / 60)
      this.viewDurationTime = '<strong>' + h.toString() + '</strong>hr <strong>' + (m < 10 ? '0' : '') + m.toString() + '</strong>min'
    },
    setStartTime: function (duration) {
      this.viewStartTime = moment(new Date(new Date().getTime() - duration * 60000)).format('HH:mm')
    },
    setPinGps: function (pinInfo) {
      this.pinGps = pinInfo
      this.setPinPosition()
    },
    setPinPosition: function () {
      this.pinPostion = this.pos2Pix(this.pinRealTimeData.imageInfo.points, this.pinGps.lat, this.pinGps.lon, this.mapAreaSize, this.mapAreaSize)
    },
    resizeEvt: function () {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          this.mapAreaSize = document.querySelector('.object0105 .content').clientHeight
          this.setPinPosition()
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          this.mapAreaSize = document.querySelector('.object0105 .content').clientHeight
          this.setPinPosition()
        }
      }
    },
    confirmSendAlarm: function () {
      this.beforeConfirm = true
      this.alertBodyHTML = this.$t('gr301.confirmSendAlarmMessage', { course: this.currentCourseInfo.name, hole: this.currentHoleNo })
      this.openAlert(this.alertBodyHTML, function () {
        this.sendAlarmPin()
      })
    },
    sendAlarmPin: function () {
      let targetClub = this.clubInfoList.find(club => club.ccode === this.currentClubCode)
      settingService.insertPushAlarm({
        funcId: '4',
        pageId: 'GR-301-1',
        message: `${targetClub.club_name}-${this.currentCourseInfo.name}-${this.currentHoleNo}`,
        pageQuery: `?ccode=${targetClub.ccode}`
      }).then(response => {
        if (response.statusCode === 200) {
          this.beforeConfirm = false
          this.openAlert(this.$t('gr301.alarmSent'))
        }
      })
    },
    openAlert: function (html, cb = null) {
      this.alertBodyHTML = html
      this.callback = cb
      document.querySelector('body.type-content').classList.add('alertActive')
    },
    closeAndCancelAlert: function () {
      this.alertBodyHTML = ''
      document.querySelector('body.type-content').classList.remove('alertActive')
      if (this.callback === null) return
      this.callback = null
    },
    closeAlert: function () {
      this.alertBodyHTML = ''
      document.querySelector('body.type-content').classList.remove('alertActive')
      if (this.callback === null) return
      this.callback()
      this.callback = null
    }
  },
  computed: {
    currentHoleNo: function () {
      return 'Hole ' + this.viewHoleNo(this.currentHlidx)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gcs/GR301.vue